import {ModalBase} from '../ModalBase'

const ModalAnularFactura2 = (props: any) => {
  return (
    <ModalBase>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'><h2 className='card-title l'>Anular documento</h2></div>
          <div className='form-separator'></div>
          <div className='m'>
            <p>Estás a punto de anular el siguiente documento, ¿deseas continuar?</p>
            {props.detail && (<p><b>Documento:</b> {props.detail} </p>)}
          </div>
          <p className='m' style={{color: '#019FC5'}}>Nota: ten en cuenta que no podrás visualizar la factura, porque estará anulada y te redirigirá a realizar una nueva factura.</p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={props.closeModalEliminar}><div>Cancelar</div></button>
            <button className='m button delete w-inline-block' onClick={props.actionEliminar}><div>Anular</div></button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalAnularFactura2
